(() => {
  'use strict';
  const savedKey = 'worth-it-saved-v1';
  const pinKey = 'worth-it-pincode-v1';
  const recentKey = 'worth-it-recently-viewed-v1';
  let saved = [];
  let pin = '';
  let toastTimer;
  let wishlistController;
  let wishlistRequest = 0;
  let wishlistStorageAvailable = true;
  let saveControlsReady = false;
  const handlePattern = /^[a-z0-9][a-z0-9-]*$/;
  const pinPattern = /^[1-9][0-9]{5}$/;
  let recent = readRecentHistory();
  let recentController;
  let recentRequest = 0;
  let recordedRecentHandle;
  let recentRoot;
  try {
    saved = readSaved();
    const storedPin = localStorage.getItem(pinKey) || '';
    if (pinPattern.test(storedPin)) pin = storedPin;
  } catch (_) { /* Shopping continues when browser storage is unavailable. */ }

  function toast(message) {
    const element = document.querySelector('[data-wi-toast]');
    if (!element) return;
    clearTimeout(toastTimer);
    element.textContent = message;
    element.hidden = false;
    toastTimer = setTimeout(() => { element.hidden = true; }, 4500);
  }

  function persistSaved() {
    try { localStorage.setItem(savedKey, JSON.stringify(saved)); return true; }
    catch (_) { wishlistStorageAvailable = false; return false; }
  }

  function syncSavedButtons() {
    document.querySelectorAll('[data-wi-save]').forEach(button => {
      const active = saved.includes(button.dataset.wiSave);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Save'} ${button.dataset.productTitle || 'product'} ${active ? 'from' : 'to'} your wishlist`);
      if (saveControlsReady) button.hidden = false;
    });
    document.querySelectorAll('[data-wi-saved-count]').forEach(counter => {
      counter.textContent = String(saved.length);
      counter.hidden = saved.length === 0;
    });
  }

  function syncPin() {
    document.querySelectorAll('[data-wi-pin-label]').forEach(label => { label.textContent = pin ? `Pincode ${pin} · Change` : 'Enter pincode'; });
    const input = document.querySelector('#WorthItPinInput');
    if (input) input.value = pin;
  }

  function canRestoreDialogFocus(element) {
    if (!element?.isConnected || typeof element.focus !== 'function' || element.matches(':disabled')) return false;
    if (element.closest('[hidden], [inert], [aria-hidden="true"], dialog:not([open])') || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  }

  function restoreDialogFocus(dialog) {
    // A parent dialog can finish closing after its replacement has opened.
    if (document.querySelector('dialog[open]')) return;
    const trigger = dialog.wiTrigger;
    const triggerKind = trigger?.dataset.wiOpen || (trigger?.closest('.wi-category-menu') ? 'WorthItCategories' : '');
    const candidates = [trigger];
    if (triggerKind === 'WorthItCategories') candidates.push(...document.querySelectorAll('.wi-category-menu summary'));
    if (triggerKind) candidates.push(...[...document.querySelectorAll('[data-wi-open]')].filter(element => element.dataset.wiOpen === triggerKind));
    candidates.push(...document.querySelectorAll('.wi-header-section .wi-brand'), document.getElementById('WorthItSearch'), document.getElementById('cart-icon-bubble'), document.getElementById('MainContent'));
    for (const candidate of new Set(candidates)) {
      if (!canRestoreDialogFocus(candidate)) continue;
      candidate.focus({ preventScroll: true });
      if (document.activeElement === candidate) return;
    }
  }

  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.id === 'WorthItWishlist' && wishlistCommerceBusy()) { toast('Check your cart before returning to saved items.'); return true; }
    wishlistHandoff = null;
    const parentDialog = trigger?.closest('dialog[open]');
    const parentMenu = trigger?.closest('.wi-category-menu[open]');
    const searchDiscovery = trigger?.closest('[data-wi-empty-search]');
    const restoreTarget = parentDialog?.wiTrigger || parentMenu?.querySelector('summary') || searchDiscovery?.closest('.wi-search')?.querySelector('input[type="search"]') || trigger;
    document.querySelectorAll('.wi-dialog[open]').forEach(other => other.close());
    document.querySelectorAll('.wi-category-menu[open]').forEach(menu => { menu.open = false; });
    dialog.wiTrigger = restoreTarget;
    try { if (!dialog.open) dialog.showModal(); } catch (_) { return false; }
    if (dialog.id === 'WorthItWishlist') loadWishlist();
    return true;
  }

  function initSearchDiscovery() {
    const input = document.querySelector('#WorthItSearch');
    const owner = input?.closest('.wi-search');
    const panel = owner?.querySelector('[data-wi-empty-search]');
    if (!input || !panel || owner.wiDiscoveryInitialized) return;
    owner.wiDiscoveryInitialized = true;
    let dismissed = false;
    const sync = () => { panel.hidden = dismissed || input.value.trim() !== '' || !owner.contains(document.activeElement); };
    owner.addEventListener('focusin', sync);
    owner.addEventListener('focusout', () => { setTimeout(() => { if (!owner.contains(document.activeElement)) dismissed = false; sync(); }, 0); });
    input.addEventListener('input', () => { dismissed = false; sync(); });
    input.addEventListener('click', () => { if (!input.value.trim()) { dismissed = false; sync(); } });
    input.form.addEventListener('reset', () => { dismissed = false; setTimeout(sync, 0); });
    owner.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) { dismissed = true; panel.hidden = true; input.focus(); event.preventDefault(); }
    });
    sync();
  }

  let stickyVisibilityRefresh;
  let stickyCleanup;
  let stickyAttentionScheduled = false;
  function updateHeaderOffset() {
    const header = document.querySelector('.wi-header-section');
    if (header) document.documentElement.style.setProperty('--wi-header-offset', `${Math.ceil(header.getBoundingClientRect().height) + 16}px`);
    stickyVisibilityRefresh?.();
  }
  let headerObserver;
  let observedHeader;
  function bindHeaderMeasurement() {
    const header = document.querySelector('.wi-header-section');
    if (header !== observedHeader) {
      headerObserver?.disconnect();
      observedHeader = header;
      if (header && 'ResizeObserver' in window) {
        headerObserver = new ResizeObserver(updateHeaderOffset);
        headerObserver.observe(header);
      }
    }
    updateHeaderOffset();
  }

  function textElement(tag, value, className) {
    const node = document.createElement(tag);
    node.textContent = value;
    if (className) node.className = className;
    return node;
  }

  function formatWishlistMoney(amount, currency) {
    const value = Number(amount) / 100;
    const options = { style: 'currency', currency };
    if (currency === 'INR') {
      options.minimumFractionDigits = Number.isInteger(value) ? 0 : 2;
      options.maximumFractionDigits = 2;
    }
    return new Intl.NumberFormat('en-IN', options).format(value);
  }

  function wishlistRemoveButton(handle) {
    const button = textElement('button', '×', 'wi-icon-button');
    button.type = 'button';
    button.dataset.wiRemoveSaved = handle;
    button.setAttribute('aria-label', `Remove ${handle.replaceAll('-', ' ')} from wishlist`);
    return button;
  }

  function normalizeSaved(value) {
    if (!Array.isArray(value)) return [];
    return [...new Set(value.filter(handle => typeof handle === 'string' && handle.length <= 200 && handlePattern.test(handle)))].slice(0, 100);
  }

  function readSaved(value) {
    if (value === undefined && !wishlistStorageAvailable) return saved;
    try {
      const raw = value === undefined ? localStorage.getItem(savedKey) : value;
      if (raw && raw.length > 24000) return [];
      return normalizeSaved(JSON.parse(raw || '[]'));
    } catch (_) { if (value === undefined) wishlistStorageAvailable = false; return value === undefined ? saved : []; }
  }

  let wishlistLimit = 12;
  let wishlistResults = new Map();
  let wishlistRoot;
  let wishlistHandoff;

  function wishlistCommerceOwner() {
    return customElements.get('product-form')?.pendingCartRefresh ||
      (typeof CartItems !== 'undefined' && CartItems.getPendingOwner?.());
  }

  function wishlistCommerceBusy() {
    const cart = document.querySelector('cart-drawer');
    return Boolean(wishlistCommerceOwner() || cart?.openTimeout != null || document.querySelector('cart-drawer.active, cart-notification.active, .product-form__cart-recovery'));
  }

  function suspendWishlist(dialog, origin, modal) {
    if (!dialog?.isConnected) return;
    wishlistHandoff = { dialog, origin, modal, seenOpen: false, submitting: false };
    if (dialog.open) { dialog.wiHandoffClose = true; dialog.close(); }
  }

  function resumeWishlist() {
    const handoff = wishlistHandoff;
    if (!handoff || handoff.submitting || wishlistCommerceBusy() || handoff.modal?.showController || handoff.modal?.hasAttribute('open')) return;
    // A shopper who navigates to another control during a handoff owns that focus.
    const active = document.activeElement;
    if (active && active !== document.body && active !== handoff.origin &&
        !active.closest('cart-drawer, cart-notification, quick-add-modal') &&
        active !== document.getElementById('cart-icon-bubble')) {
      wishlistHandoff = null;
      return;
    }
    wishlistHandoff = null;
    if (!handoff.dialog.isConnected || !handoff.origin?.isConnected || !saved.length || document.querySelector('dialog[open]')) return;
    try { handoff.dialog.showModal(); } catch (_) { return; }
    if (handoff.dialog.wiNeedsRefresh) { handoff.dialog.wiNeedsRefresh = false; loadWishlist(); }
    else if (canRestoreDialogFocus(handoff.origin)) handoff.origin.focus({ preventScroll: true });
  }

  function retireWishlistModal(modal) {
    if (!modal) return;
    // Cancel pending chooser GETs before removing their body-owned nodes.
    modal.cancelShow?.();
    if (modal.hasAttribute('open')) modal.hide?.(true);
    modal.remove();
  }

  function clearWishlistCards(dialog) {
    (dialog?.wiSavedModalIds || []).forEach(id => retireWishlistModal(document.getElementById(id)));
    if (dialog) dialog.wiSavedModalIds = [];
  }

  function cancelWishlist(dialog, retire = false) {
    ++wishlistRequest;
    wishlistController?.abort();
    dialog?.removeAttribute('aria-busy');
    if (retire) clearWishlistCards(dialog);
  }

  async function fetchSavedCard(handle, rootURL, signal) {
    const controller = new AbortController();
    let deadline, stop;
    const stopped = new Promise((_, reject) => {
      stop = () => { controller.abort(); reject(new DOMException('Request aborted', 'AbortError')); };
      signal.addEventListener('abort', stop, { once: true });
      deadline = setTimeout(() => { controller.abort(); reject(new Error('Saved product request timed out')); }, 8000);
      if (signal.aborted) stop();
    });
    const loading = (async () => {
      const url = new URL(`${rootURL}products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('section_id', 'worth-it-saved-card');
      const response = await fetch(url.href, { cache: 'no-store', signal: controller.signal });
      if (response.status === 404) return { handle, deleted: true };
      if (!response.ok) throw new Error('Saved product is unavailable');
      const html = await response.text();
      const card = new DOMParser().parseFromString(html, 'text/html').querySelector('template[data-wi-saved-card]');
      if (card?.dataset.wiSavedCard !== handle || !/^[1-9][0-9]*$/.test(card.dataset.productId || '') || !card.content.querySelector('.product-card-wrapper')) throw new Error('Saved product card is unavailable');
      // Each native ID belongs to this surface; never adopt a Home/recent modal.
      if ([...card.content.querySelectorAll('[id]')].some(node => !(node.getAttribute('id') || '').includes(`wi-saved-${card.dataset.productId}`))) throw new Error('Saved card identity is unavailable');
      return { handle, card };
    })();
    try { return await Promise.race([loading, stopped]); }
    catch (_) { return { handle, failed: true }; }
    finally { clearTimeout(deadline); signal.removeEventListener('abort', stop); }
  }

  function bindWishlistModal(modal, dialog) {
    if (modal.wiSavedBound) return;
    modal.wiSavedBound = true;
    const nativeShow = modal.show;
    if (typeof nativeShow !== 'function') return;
    modal.show = function (origin) {
      suspendWishlist(dialog, origin, modal);
      const handoff = wishlistHandoff;
      return Promise.resolve(nativeShow.call(this, origin)).then(result => {
        if (wishlistHandoff === handoff && !result) resumeWishlist();
        return result;
      }, error => { if (wishlistHandoff === handoff) resumeWishlist(); throw error; });
    };
  }

  function renderWishlist(dialog, focusHandle) {
    const container = dialog.querySelector('[data-wi-wishlist-items]');
    const status = dialog.querySelector('[data-wi-saved-status]');
    const more = dialog.querySelector('[data-wi-saved-more]');
    const retry = dialog.querySelector('[data-wi-saved-retry]');
    const active = document.activeElement;
    const restore = Boolean(dialog.open && container.contains(active));
    clearWishlistCards(dialog);
    const fragment = new DOMParser().parseFromString('<html><body><ul class="wi-saved-grid" role="list"></ul></body></html>', 'text/html').body;
    const list = fragment.querySelector('ul');
    const handles = saved.slice(0, wishlistLimit);
    let loaded = 0, failed = 0;
    const productIds = new Set();
    handles.forEach(handle => {
      const result = wishlistResults.get(handle);
      const item = fragment.ownerDocument.createElement('li');
      item.className = 'wi-saved-item';
      item.dataset.wiSavedHandle = handle;
      if (result?.card && !productIds.has(result.card.dataset.productId)) {
        productIds.add(result.card.dataset.productId);
        const nativeCard = fragment.ownerDocument.importNode(result.card.content, true);
        nativeCard.querySelectorAll('script').forEach(script => script.remove());
        item.append(nativeCard);
        loaded++;
      } else {
        const message = result?.deleted ? 'This product is no longer available at this address.' : 'Could not load this product. Your saved item is still here.';
        item.append(textElement('p', handle.replaceAll('-', ' '), 'wi-saved-item__title'), textElement('p', message, 'wi-muted'));
        const link = textElement('a', 'View product');
        link.href = `${(dialog.dataset.root || '/').replace(/\/?$/, '/')}products/${encodeURIComponent(handle)}`;
        item.append(link);
        if (!result?.deleted) failed++;
      }
      const remove = wishlistRemoveButton(handle);
      remove.className = 'wi-text-button wi-saved-remove';
      remove.textContent = 'Remove';
      item.append(remove);
      list.append(item);
    });
    dialog.wiSavedModalIds = [...fragment.querySelectorAll('quick-add-modal[id]')].map(modal => modal.id);
    container.replaceChildren(...[...fragment.childNodes].map(node => document.adoptNode(node)));
    if (!saved.length) {
      const empty = textElement('div', '', 'wi-empty');
      empty.append(textElement('h3', 'Your next worth-it find belongs here.'), textElement('p', 'Tap a product heart to save it on this browser.'));
      let fallback = `${location.origin}/collections/all`;
      try {
        const root = new URL(dialog.dataset.root || '/', location.origin);
        if (root.origin === location.origin) fallback = new URL(`${root.pathname.replace(/\/?$/, '/')}collections/all`, location.origin).href;
      } catch (_) { /* Use the same-store fallback if the route is unavailable. */ }
      let href = fallback, label = 'Browse all finds';
      try {
        const target = new URL(dialog.dataset.emptyBrowse || fallback, location.origin);
        if (target.origin === location.origin && /^(https?:)$/.test(target.protocol)) { href = target.href; label = dialog.dataset.emptyLabel || label; }
      } catch (_) { /* Invalid routes never become an external browse link. */ }
      const browse = textElement('a', label, 'button');
      browse.href = href;
      empty.append(browse); container.replaceChildren(empty);
    }
    container.querySelectorAll('product-form, modal-opener, quick-add-modal').forEach(element => customElements.upgrade?.(element));
    dialog.wiSavedModalIds.forEach(id => { const modal = document.getElementById(id); if (modal) bindWishlistModal(modal, dialog); });
    status.textContent = saved.length ? `${Math.min(wishlistLimit, saved.length)} of ${saved.length} saved items · ${loaded} current product${loaded === 1 ? '' : 's'} loaded.${failed ? ' Some could not load. Try again.' : ''}${wishlistStorageAvailable ? '' : ' Browser storage is unavailable; changes last for this visit.'}` : 'Saved items are kept only on this browser.';
    more.hidden = wishlistLimit >= saved.length;
    more.textContent = `Load more (${Math.min(12, Math.max(0, saved.length - wishlistLimit))})`;
    retry.hidden = !failed;
    more.disabled = retry.disabled = false;
    syncSavedButtons();
    if (dialog.open && (active === retry && retry.hidden || active === more && more.hidden)) {
      (container.querySelector('[data-wi-remove-saved]') || container.querySelector('a') || dialog.querySelector('[data-wi-close]'))?.focus({ preventScroll: true });
    }
    if (restore && dialog.open && (document.activeElement === document.body || !active.isConnected || document.activeElement === active)) {
      const candidate = [...container.querySelectorAll('[data-wi-remove-saved]')].find(button => button.dataset.wiRemoveSaved === focusHandle) || container.querySelector('[data-wi-remove-saved]') || container.querySelector('a') || dialog.querySelector('[data-wi-close]');
      candidate?.focus({ preventScroll: true });
    }
  }

  function restoreWishlistRequestFocus(dialog, origin) {
    if (!origin || !dialog.open || !dialog.isConnected) return;
    const active = document.activeElement;
    if (active !== document.body && active !== origin) return;
    const target = canRestoreDialogFocus(origin) ? origin :
      dialog.querySelector('[data-wi-remove-saved]') || dialog.querySelector('[data-wi-wishlist-items] a') || dialog.querySelector('[data-wi-close]');
    if (canRestoreDialogFocus(target)) target.focus({ preventScroll: true });
  }

  async function loadWishlist(mode = 'refresh', focusHandle) {
    const dialog = document.querySelector('#WorthItWishlist');
    if (!dialog?.open || !dialog.isConnected) return;
    if (wishlistRoot && wishlistRoot !== dialog) clearWishlistCards(wishlistRoot);
    wishlistRoot = dialog;
    // Chrome can blur a focused button when it becomes disabled. Capture its
    // ownership before loading; completion must not steal a shopper’s new focus.
    const focused = document.activeElement;
    const focusOwner = focused === dialog.querySelector('[data-wi-saved-more]') || focused === dialog.querySelector('[data-wi-saved-retry]') ? focused : null;
    const request = ++wishlistRequest;
    wishlistController?.abort();
    const controller = new AbortController();
    wishlistController = controller;
    if (mode === 'refresh') {
      wishlistLimit = 12; wishlistResults = new Map();
      clearWishlistCards(dialog);
      dialog.querySelector('[data-wi-wishlist-items]').replaceChildren();
    }
    const previousLimit = wishlistLimit;
    if (mode === 'more') wishlistLimit = Math.min(100, wishlistLimit + 12);
    const handles = saved.slice(mode === 'more' ? previousLimit : 0, wishlistLimit).filter(handle => mode === 'refresh' || (!wishlistResults.get(handle)?.card && !wishlistResults.get(handle)?.deleted));
    if (!saved.length) { renderWishlist(dialog, focusHandle); return; }
    dialog.setAttribute('aria-busy', 'true');
    dialog.querySelector('[data-wi-saved-status]').textContent = mode === 'more' ? 'Loading more saved products…' : 'Loading current saved products…';
    dialog.querySelector('[data-wi-saved-more]').disabled = true;
    dialog.querySelector('[data-wi-saved-retry]').disabled = true;
    let rootURL;
    try {
      const url = new URL(dialog.dataset.root || '/', location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid route');
      rootURL = url.pathname.replace(/\/?$/, '/');
    } catch (_) { dialog.removeAttribute('aria-busy'); handles.forEach(handle => wishlistResults.set(handle, { handle, failed: true })); renderWishlist(dialog, focusHandle); restoreWishlistRequestFocus(dialog, focusOwner); return; }
    let next = 0;
    // A page has one 10s budget, including later workers' response bodies.
    const budget = setTimeout(() => controller.abort(), 10000);
    const results = new Map();
    await Promise.all(Array.from({ length: Math.min(3, handles.length) }, async () => {
      while (next < handles.length && !controller.signal.aborted) {
        const handle = handles[next++];
        results.set(handle, await fetchSavedCard(handle, rootURL, controller.signal));
      }
    }));
    clearTimeout(budget);
    if (request !== wishlistRequest || !dialog.isConnected || (!dialog.open && wishlistHandoff?.dialog !== dialog)) return;
    handles.forEach(handle => { if (saved.includes(handle)) wishlistResults.set(handle, results.get(handle) || { handle, failed: true }); });
    dialog.removeAttribute('aria-busy');
    // Keep genuine cards stable while their native form/chooser is in use.
    if (wishlistHandoff?.dialog === dialog) { dialog.wiNeedsRefresh = true; return; }
    renderWishlist(dialog, focusHandle);
    restoreWishlistRequestFocus(dialog, focusOwner);
  }

  function savedListChanged(focusHandle) {
    syncSavedButtons();
    const dialog = document.querySelector('#WorthItWishlist');
    cancelWishlist(dialog);
    if (wishlistHandoff?.dialog === dialog) {
      dialog.wiNeedsRefresh = true;
      // Keep the active commerce owner reachable; retire unused chooser nodes.
      if (!saved.includes(wishlistHandoff.origin?.closest('[data-wi-saved-handle]')?.dataset.wiSavedHandle)) {
        const handoff = wishlistHandoff;
        wishlistHandoff = null;
        retireWishlistModal(handoff.modal);
      }
      return;
    }
    if (dialog?.open) {
      wishlistResults = new Map([...wishlistResults].filter(([handle]) => saved.includes(handle)));
      renderWishlist(dialog, focusHandle);
      loadWishlist('retry', focusHandle);
    } else clearWishlistCards(dialog);
  }

  document.addEventListener('submit', event => {
    const productForm = event.target.closest('product-form');
    const dialog = productForm?.closest('#WorthItWishlist');
    const ownedModal = productForm?.closest('quick-add-modal');
    const existing = wishlistHandoff;
    if ((!dialog && ownedModal !== existing?.modal) || !productForm?.pendingAddPromise) return;
    if (dialog) suspendWishlist(dialog, event.submitter || productForm.submitButton, null);
    const handoff = wishlistHandoff;
    if (!handoff) return;
    handoff.submitting = true;
    // Completion is used only to release a wait; cart/recovery truth owns return.
    Promise.resolve(productForm.pendingAddPromise).finally(() => {
      if (wishlistHandoff !== handoff) return;
      handoff.submitting = false;
      setTimeout(resumeWishlist, 0);
    });
  });

  new MutationObserver(() => {
    if (wishlistRoot && !wishlistRoot.isConnected) { cancelWishlist(wishlistRoot, true); wishlistRoot = null; wishlistHandoff = null; }
    const handoff = wishlistHandoff;
    if (!handoff) return;
    if (!handoff.dialog.isConnected || !handoff.origin?.isConnected) { wishlistHandoff = null; return; }
    if (wishlistCommerceBusy() || handoff.modal?.hasAttribute('open')) handoff.seenOpen = true;
    else if (handoff.seenOpen && !handoff.submitting && !handoff.modal?.showController) resumeWishlist();
  }).observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'open'] });
  document.body.addEventListener('modalClosed', () => { setTimeout(resumeWishlist, 0); });

  function normalizeRecentHistory(value) {
    if (!Array.isArray(value)) return [];
    return [...new Set(value.slice(0, 64).filter(handle => typeof handle === 'string' && handle.length <= 200 && handlePattern.test(handle)))].slice(0, 8);
  }

  function readRecentHistory(value) {
    try {
      const raw = value === undefined ? localStorage.getItem(recentKey) : value;
      return raw && raw.length <= 8192 ? normalizeRecentHistory(JSON.parse(raw)) : [];
    } catch (_) { return []; }
  }

  function persistRecentHistory() {
    try {
      if (recent.length) localStorage.setItem(recentKey, JSON.stringify(recent));
      else localStorage.removeItem(recentKey);
      return true;
    } catch (_) { return false; }
  }

  function recordRecentVisit() {
    // Quick Add product-info elements are not genuine page visits.
    const info = document.querySelector('#MainContent product-info[id^="MainProduct-"][data-update-url="true"]');
    if (!info?.dataset.url || info.closest('quick-add-modal, dialog')) return;
    try {
      const url = new URL(info.dataset.url, location.origin);
      const handle = url.pathname.replace(/\/$/, '').split('/').pop();
      if (url.origin !== location.origin || !handlePattern.test(handle) || handle.length > 200 || !location.pathname.replace(/\/$/, '').endsWith(`/products/${handle}`) || recordedRecentHandle === handle) return;
      recordedRecentHandle = handle;
      recent = normalizeRecentHistory([handle, ...recent]);
      persistRecentHistory();
    } catch (_) { /* Invalid product context does not create history. */ }
  }

  function focusRecentShoppingHeading() {
    const heading = document.querySelector('#WorthItDiwaliFinds h2') || document.getElementById('MainContent');
    if (heading?.isConnected) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); heading.scrollIntoView?.({ block: 'center' }); }
  }

  function clearRecentCards(root) {
    const container = root.querySelector('[data-wi-recent-items]');
    let restore = container?.contains(document.activeElement);
    // Dawn moves Quick Add dialogs to body. Remove only this shelf's owned
    // dialogs when replacing cards, so their IDs cannot survive a refresh.
    (root.wiRecentModalIds || []).forEach(id => {
      const modal = document.getElementById(id);
      if (!modal) return;
      restore = restore || modal.contains(document.activeElement) || modal.hasAttribute('open');
      if (modal.hasAttribute('open')) modal.hide?.();
      modal.remove();
    });
    root.wiRecentModalIds = [];
    if (restore) {
      const clear = root.querySelector('[data-wi-recent-clear]');
      if (clear?.isConnected && !root.hidden) clear.focus({ preventScroll: true });
      else focusRecentShoppingHeading();
    }
    container?.replaceChildren();
  }

  function hideRecentShelf(root) {
    clearRecentCards(root);
    if (root.contains(document.activeElement)) focusRecentShoppingHeading();
    root.hidden = true;
    root.removeAttribute('aria-busy');
    const status = root.querySelector('[data-wi-recent-status]');
    if (status) status.textContent = '';
    const retry = root.querySelector('[data-wi-recent-retry]');
    if (retry) retry.hidden = true;
  }

  async function fetchRecentCard(handle, rootURL, signal) {
    const controller = new AbortController();
    let timer;
    let stop;
    // The deadline covers both response headers and the body, even if fetch ignores abort.
    const stopped = new Promise((_, reject) => {
      stop = () => { controller.abort(); reject(new DOMException('Request aborted', 'AbortError')); };
      signal.addEventListener('abort', stop, { once: true });
      timer = setTimeout(() => { controller.abort(); reject(new Error('Product request timed out')); }, 8000);
      if (signal.aborted) stop();
    });
    const loading = (async () => {
      const url = new URL(`${rootURL}products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('section_id', 'worth-it-recent-card');
      // Section Rendering returns HTML; do not force JSON content negotiation.
      const response = await fetch(url.href, { signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error('Product could not be loaded');
      const html = await response.text();
      const section = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-worth-it-recent-card');
      const card = section?.querySelector('template[data-wi-recent-card]');
      const unavailable = section?.querySelector('template[data-wi-recent-unavailable]');
      if (unavailable && !card) return { handle, deleted: true };
      if (unavailable || card?.dataset.wiRecentCard !== handle || !/^[1-9][0-9]*$/.test(card.dataset.productId || '') || !card.content.querySelector('.product-card-wrapper')) throw new Error('Product card is unavailable');
      return { handle, card };
    })();
    try { return await Promise.race([loading, stopped]); }
    catch (_) { return { handle, failed: true }; }
    finally { clearTimeout(timer); signal.removeEventListener('abort', stop); }
  }

  function renderRecentCards(root, results) {
    const container = root.querySelector('[data-wi-recent-items]');
    const source = root.querySelector('[data-wi-recent-shelf]');
    clearRecentCards(root);
    const cards = results.filter(result => result.card);
    if (!cards.length || !source) return;
    // Assemble in an inert document. Native components upgrade only after all
    // their form/modal/slider children exist in the final inserted markup.
    const fragment = new DOMParser().parseFromString(`<html><body>${source.innerHTML}</body></html>`, 'text/html').body;
    const list = fragment.querySelector('ul');
    const scrolls = cards.length > 2;
    if (scrolls) {
      list.classList.add('wi-product-shelf', 'slider', 'slider--mobile');
      list.setAttribute('tabindex', '0');
      list.setAttribute('aria-describedby', fragment.querySelector('[data-wi-recent-hint]').id);
    } else {
      fragment.querySelector('[data-wi-recent-controls]').remove();
      fragment.querySelector('[data-wi-recent-hint]').remove();
    }
    cards.forEach(({ card }) => {
      const item = fragment.ownerDocument.createElement('li');
      item.id = `${list.id.replace(/^Slider-/, 'Slide-')}-${card.dataset.productId}`;
      item.className = `grid__item${scrolls ? ' slider__slide' : ''}`;
      const nativeCard = fragment.ownerDocument.importNode(card.content, true);
      nativeCard.querySelectorAll('script').forEach(script => script.remove());
      item.append(nativeCard);
      list.append(item);
    });
    const total = fragment.querySelector('.slider-counter--total');
    if (total) total.textContent = String(cards.length);
    root.wiRecentModalIds = [...fragment.querySelectorAll('quick-add-modal[id]')].map(modal => modal.id);
    container.replaceChildren(...[...fragment.childNodes].map(node => document.adoptNode(node)));
    // Explicit upgrade also supports delayed definitions without cloning an
    // already-constructed native component with incomplete children.
    container.querySelectorAll('slider-component, product-form, modal-opener, quick-add-modal').forEach(element => customElements.upgrade?.(element));
    container.querySelector('slider-component')?.resetPages?.();
    syncSavedButtons();
  }

  async function loadRecentlyViewed(root) {
    const request = ++recentRequest;
    recentController?.abort();
    recentController = new AbortController();
    const signal = recentController.signal;
    const handles = [...recent];
    if (!handles.length) { hideRecentShelf(root); return; }
    root.hidden = false;
    root.setAttribute('aria-busy', 'true');
    const status = root.querySelector('[data-wi-recent-status]');
    const retry = root.querySelector('[data-wi-recent-retry]');
    clearRecentCards(root);
    status.textContent = 'Loading your recently viewed products…';
    if (document.activeElement === retry) root.querySelector('[data-wi-recent-clear]')?.focus({ preventScroll: true });
    retry.hidden = true;
    let rootURL;
    try {
      const url = new URL(root.dataset.root || '/', location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid store route');
      rootURL = url.pathname.replace(/\/?$/, '/');
    } catch (_) {
      root.removeAttribute('aria-busy');
      status.textContent = 'Could not load your recently viewed products.';
      retry.hidden = false;
      return;
    }
    const results = new Array(handles.length);
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(3, handles.length) }, async () => {
      while (next < handles.length && !signal.aborted) {
        const index = next++;
        results[index] = await fetchRecentCard(handles[index], rootURL, signal);
      }
    }));
    if (signal.aborted || request !== recentRequest || !root.isConnected) return;
    const deleted = results.filter(result => result?.deleted).map(result => result.handle);
    if (deleted.length) { recent = recent.filter(handle => !deleted.includes(handle)); persistRecentHistory(); }
    root.removeAttribute('aria-busy');
    if (!recent.length) { hideRecentShelf(root); return; }
    renderRecentCards(root, results);
    const failed = results.some(result => result.failed);
    status.textContent = failed ? 'Some recently viewed products could not be loaded. Try again.' : '';
    retry.hidden = !failed;
  }

  function initRecentlyViewed() {
    recordRecentVisit();
    const root = document.querySelector('[data-wi-recently-viewed]');
    if (recentRoot && recentRoot !== root) clearRecentCards(recentRoot);
    recentRoot = root;
    if (root) loadRecentlyViewed(root);
    else { ++recentRequest; recentController?.abort(); }
  }

  function clearRecentHistory(root) {
    ++recentRequest;
    recentController?.abort();
    recent = [];
    const persisted = persistRecentHistory();
    hideRecentShelf(root);
    toast(persisted ? 'Viewing history cleared from this browser.' : 'Viewing history cleared for this visit. Browser storage is unavailable.');
  }

  document.addEventListener('click', event => {
    const recentClear = event.target.closest('[data-wi-recent-clear]');
    if (recentClear) { clearRecentHistory(recentClear.closest('[data-wi-recently-viewed]')); return; }
    const recentRetry = event.target.closest('[data-wi-recent-retry]');
    if (recentRetry) { loadRecentlyViewed(recentRetry.closest('[data-wi-recently-viewed]')); return; }
    document.querySelectorAll('.wi-category-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
    const saveButton = event.target.closest('[data-wi-save]');
    if (saveButton) {
      const handle = saveButton.dataset.wiSave;
      if (typeof handle !== 'string' || handle.length > 200 || !handlePattern.test(handle)) return;
      const active = saved.includes(handle);
      if (!active && saved.length >= 100) { toast('Your wishlist is full. Remove a saved find first.'); return; }
      saved = active ? saved.filter(value => value !== handle) : [...saved, handle];
      const persisted = persistSaved();
      wishlistStorageAvailable = persisted;
      savedListChanged();
      toast(active ? 'Removed from saved finds.' : persisted ? 'Saved for later.' : 'Saved for this visit. Browser storage is unavailable.');
      return;
    }
    const remove = event.target.closest('[data-wi-remove-saved]');
    if (remove) {
      saved = saved.filter(value => value !== remove.dataset.wiRemoveSaved);
      wishlistStorageAvailable = persistSaved();
      savedListChanged();
      return;
    }
    const savedMore = event.target.closest('[data-wi-saved-more]');
    if (savedMore) { loadWishlist('more'); return; }
    const savedRetry = event.target.closest('[data-wi-saved-retry]');
    if (savedRetry) { loadWishlist('retry'); return; }
    const keepNativeLinkGesture = element => element.matches('a[href]') &&
      (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);
    const opener = event.target.closest('[data-wi-open]');
    if (opener) {
      if (keepNativeLinkGesture(opener)) return;
      if (openDialog(document.getElementById(opener.dataset.wiOpen), opener)) event.preventDefault();
      return;
    }
    const closer = event.target.closest('[data-wi-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    const clearPin = event.target.closest('[data-wi-clear-pin]');
    if (clearPin) {
      pin = '';
      try { localStorage.removeItem(pinKey); } catch (_) {}
      syncPin();
      document.querySelector('#WorthItPinStatus').textContent = 'Saved pincode cleared.';
      return;
    }
    const focusSearch = event.target.closest('[data-wi-search-focus]');
    if (focusSearch) {
      if (keepNativeLinkGesture(focusSearch)) return;
      const search = document.querySelector('#WorthItSearch');
      if (search) { event.preventDefault(); window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); search.focus({ preventScroll: true }); }
      return;
    }
    const cartTrigger = event.target.closest('[data-wi-cart-open]');
    const cart = document.querySelector('cart-drawer');
    if (cartTrigger && keepNativeLinkGesture(cartTrigger)) return;
    if (cartTrigger && cart?.open) { event.preventDefault(); cart.open(cartTrigger); }
    const stickyButton = event.target.closest('[data-wi-sticky-submit]');
    if (stickyButton) {
      event.preventDefault();
      const sticky = stickyButton.closest('[data-wi-sticky-buy]');
      const state = stickyPurchaseState(sticky);
      if (sticky?.classList.contains('is-visible') && !sticky.hidden && !sticky.inert && !stickyButton.disabled && !stickyBlockedByLayer() && state.ready) {
        try { state.form.requestSubmit(state.nativeAdd); }
        finally { sticky.wiSync?.(); }
      }
      return;
    }
    const stickyCheckout = event.target.closest('[data-wi-sticky-checkout]');
    if (stickyCheckout) {
      event.preventDefault();
      const sticky = stickyCheckout.closest('[data-wi-sticky-buy]');
      const state = stickyPurchaseState(sticky);
      if (sticky?.classList.contains('is-visible') && !sticky.hidden && !sticky.inert && !stickyCheckout.hidden && !stickyCheckout.disabled && !stickyBlockedByLayer() && !sticky.wiBuyPending && state.buyReady) {
        // Shopify's existing native control owns checkout, variant and quantity.
        // This proxy never adds a line or navigates to a hand-built checkout URL.
        sticky.wiBuyPending = true;
        sticky.wiSync?.();
        try { state.nativeBuy.click(); }
        catch (_) { sticky.wiBuyPending = false; sticky.wiSync?.(); }
        if (sticky.wiBuyPending) sticky.wiBuyCooldown = setTimeout(() => { sticky.wiBuyPending = false; sticky.wiSync?.(); }, 1500);
      }
      return;
    }
    const stickyErrorLink = event.target.closest('[data-wi-sticky-error-link]');
    if (stickyErrorLink) {
      const sticky = stickyErrorLink.closest('[data-wi-sticky-buy]');
      const state = stickyPurchaseState(sticky);
      if (sticky?.classList.contains('is-visible') && !sticky.hidden && !sticky.inert && !stickyBlockedByLayer() && state.errorWrapper) {
        event.preventDefault();
        state.errorWrapper.scrollIntoView({ block: 'center', behavior: 'auto' });
        if (!state.errorWrapper.hasAttribute('tabindex')) state.errorWrapper.setAttribute('tabindex', '-1');
        state.errorWrapper.focus({ preventScroll: true });
      }
      return;
    }
    const stickyEdit = event.target.closest('[data-wi-sticky-edit]');
    if (stickyEdit) {
      const sticky = stickyEdit.closest('[data-wi-sticky-buy]');
      const state = stickyPurchaseState(sticky);
      const target = state.product?.querySelector('variant-selects input:not([disabled]), variant-selects select:not([disabled])') || state.quantity || state.nativeAdd;
      if (target?.isConnected && target.getClientRects().length) {
        event.preventDefault();
        target.scrollIntoView({ block: 'center', behavior: 'auto' });
        target.focus({ preventScroll: true });
      }
    }
  });

  saveControlsReady = true;
  syncSavedButtons();

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.wi-category-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); event.preventDefault(); }
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.wi-category-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });

  function bindDialogs() { document.querySelectorAll('.wi-dialog').forEach(dialog => {
    if (dialog.wiDialogBound) return;
    dialog.wiDialogBound = true;
    dialog.addEventListener('close', () => {
      if (dialog.wiHandoffClose) { dialog.wiHandoffClose = false; return; }
      if (dialog.id === 'WorthItWishlist') { wishlistHandoff = null; cancelWishlist(dialog, true); }
      restoreDialogFocus(dialog);
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
  }); }
  bindDialogs();

  document.querySelector('[data-wi-pin-form]')?.addEventListener('submit', event => {
    event.preventDefault();
    const input = document.querySelector('#WorthItPinInput');
    const status = document.querySelector('#WorthItPinStatus');
    const value = input.value.trim();
    if (!pinPattern.test(value)) { status.textContent = 'Enter a valid 6-digit Indian pincode.'; input.focus(); return; }
    pin = value;
    let persisted = true;
    try { localStorage.setItem(pinKey, pin); } catch (_) { persisted = false; }
    syncPin();
    status.textContent = persisted ? 'Pincode saved. Delivery options and charges will be confirmed at checkout.' : 'Saved for this visit. Delivery options and charges will be confirmed at checkout.';
  });

  function syncCartCount() {
    const counter = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    const count = Number(counter?.dataset.wiCartItems || 0);
    document.querySelectorAll('[data-wi-cart-count]').forEach(element => { element.textContent = String(count); element.hidden = count === 0; });
  }
  let cartIconObserver;
  let observedCartIcon;
  function bindCartCount() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon !== observedCartIcon) {
      cartIconObserver?.disconnect();
      observedCartIcon = cartIcon;
      if (cartIcon) {
        cartIconObserver = new MutationObserver(syncCartCount);
        cartIconObserver.observe(cartIcon, { childList: true, subtree: true });
      }
    }
    syncCartCount();
  }

  function stickyBlockedByLayer() {
    if (document.visibilityState !== 'visible') return true;
    const field = document.activeElement;
    if (field?.matches('input:not([type="hidden"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]')) return true;
    if (window.visualViewport && window.innerHeight - window.visualViewport.height > 150) return true;
    return [...document.querySelectorAll('dialog[open], cart-drawer.active, cart-notification.active, modal-dialog[open], product-modal[open], .product-popup-modal[open], .product-media-modal[open], .wi-privacy__details[open], [aria-modal="true"], .shopify-pc__banner, .shopify-pc__prefs__dialog')].some(layer => {
      if (layer.closest('[hidden], [aria-hidden="true"], dialog:not([open])') || !layer.getClientRects().length) return false;
      // Native dialogs keep their inner aria-modal node rendered after closing.
      // Its owning component's actual open state decides whether it obstructs.
      const drawer = layer.closest('cart-drawer');
      if (drawer && !drawer.classList.contains('active')) return false;
      const notification = layer.closest('cart-notification');
      if (notification && !notification.querySelector('.cart-notification.active')) return false;
      const modal = layer.closest('modal-dialog, product-modal, quick-add-modal, .product-popup-modal, .product-media-modal');
      if (modal && !modal.hasAttribute('open')) return false;
      const rect = layer.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth) return false;
      const style = getComputedStyle(layer);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function stickyPurchaseState(sticky) {
    const product = sticky && document.getElementById(sticky.dataset.wiProductInfo);
    const formId = sticky?.querySelector('[data-wi-sticky-submit]')?.dataset.wiStickySubmit;
    const form = formId && document.getElementById(formId);
    const nativeAdd = form?.querySelector('button[name="add"][type="submit"], [type="submit"]');
    if (!product?.hasAttribute('data-wi-product-ready') || !form || !product.contains(form) || !nativeAdd) return { ready: false, buyReady: false, product, form, nativeAdd, selectedVariant: null, errorWrapper: null, errorMessage: '' };
    const quantity = form.elements?.namedItem('quantity') || [...product.querySelectorAll('input[name="quantity"]')].find(input => input.form === form || input.getAttribute('form') === form.id);
    const count = quantity ? Number(quantity.value) : 1;
    const min = quantity ? Number(quantity.min || 1) : 1;
    const max = quantity?.hasAttribute('max') ? Number(quantity.max) : null;
    const step = quantity ? Number(quantity.step || 1) : 1;
    const quantityValid = !quantity?.disabled && quantity?.validity?.valid !== false && Number.isSafeInteger(count) && count > 0 && Number.isSafeInteger(min) && min > 0 && count >= min && Number.isSafeInteger(step) && step > 0 && (count - min) % step === 0 && (max === null || (Number.isSafeInteger(max) && count <= max));
    const variant = form.querySelector('input[name="id"]');
    const selectionConfirmed = !product.selectionUnconfirmed && !product.quantityRulesUnconfirmed && !variant?.disabled && /^\d+$/.test(variant?.value || '') && Number.isSafeInteger(Number(variant.value)) && Number(variant.value) > 0;
    let selectedVariant = null;
    if (selectionConfirmed) {
      try {
        const selected = JSON.parse(product.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null');
        if (selected && Number.isSafeInteger(selected.id) && selected.id > 0 && String(selected.id) === variant.value) selectedVariant = selected;
      } catch (_) { /* Only matching native JSON may describe the selected pack or total. */ }
    }
    const productForm = form.closest('product-form');
    const wrapper = productForm && product.contains(productForm) && productForm.querySelector('.product-form__error-message-wrapper');
    const message = wrapper?.querySelector('.product-form__error-message')?.textContent.trim() || '';
    const errorVisible = !!message && !!wrapper?.getClientRects().length && !wrapper.closest('[hidden], [inert], [aria-hidden="true"]') && getComputedStyle(wrapper).display !== 'none' && getComputedStyle(wrapper).visibility !== 'hidden';
    const errorWrapper = errorVisible ? wrapper : null;
    const busy = nativeAdd.getAttribute('aria-disabled') === 'true' || nativeAdd.getAttribute('aria-busy') === 'true' || nativeAdd.classList.contains('loading');
    const ready = selectionConfirmed && quantityValid && !product.nativeSubmitDisabled && !product.quantityUnavailable && !nativeAdd.disabled && !busy && !nativeAdd.closest('[hidden], [inert]') && !!nativeAdd.getClientRects().length;
    const nativeBuy = form.querySelector('button.shopify-payment-button__button--unbranded');
    const checkoutLocked = !!document.querySelector('button[name="checkout"][aria-busy="true"], input[name="checkout"][aria-busy="true"], .cart__dynamic-checkout-buttons[inert], .shopify-payment-button[inert]');
    const buyReady = ready && !!window.WorthItCartCheckout && !checkoutLocked && !!nativeBuy?.getClientRects().length && !nativeBuy.disabled && nativeBuy.getAttribute('aria-disabled') !== 'true' && nativeBuy.getAttribute('aria-busy') !== 'true' && !nativeBuy.closest('[hidden], [inert], [aria-hidden="true"]');
    return { product, form, nativeAdd, nativeBuy, quantity, count, quantityValid, selectionConfirmed, selectedVariant, errorWrapper, errorMessage: errorVisible ? message : '', busy, ready, buyReady };
  }

  function initStickyBuy() {
    const sticky = document.querySelector('[data-wi-sticky-buy]');
    if (!sticky) return;
    const product = document.getElementById(sticky.dataset.wiProductInfo);
    if (sticky.wiInitialized && sticky.wiBoundProduct === product) return;
    if (!product?.hasAttribute('data-wi-product-ready')) {
      if (sticky.wiInitialized) { stickyCleanup?.(); stickyVisibilityRefresh = null; }
      sticky.classList.remove('is-visible'); sticky.hidden = true; sticky.inert = true;
      return;
    }
    stickyCleanup?.();
    sticky.wiInitialized = true;
    sticky.wiBoundProduct = product;
    const button = sticky.querySelector('[data-wi-sticky-submit]');
    const buyButton = sticky.querySelector('[data-wi-sticky-checkout]');
    const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    let nativeButton;
    let attentionDelay;
    let attentionEnd;
    let disposed = false;
    let observerSyncFrame = null;
    let observerSyncVersion = 0;
    let visibilityVersion = 0;
    const cancelObserverSync = () => {
      observerSyncVersion += 1;
      if (observerSyncFrame !== null && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(observerSyncFrame);
      observerSyncFrame = null;
    };
    const reserveStickyHeight = () => {
      if (disposed || !sticky.isConnected || !product.isConnected || !sticky.classList.contains('is-visible')) return;
      const height = sticky.getBoundingClientRect().height;
      if (Number.isFinite(height) && height > 0 && height < 5000) document.documentElement?.style?.setProperty?.('--wi-sticky-bar-height', `${Math.ceil(height) + 1}px`);
    };
    const stickySizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(reserveStickyHeight) : null;
    stickySizeObserver?.observe(sticky);
    const stopAttention = () => { clearTimeout(attentionDelay); clearTimeout(attentionEnd); sticky.classList.remove('wi-sticky-buy--attention'); };
    const visibilityObserver = 'IntersectionObserver' in window ? new IntersectionObserver(() => refreshVisibility(), { threshold: [0, 1] }) : null;
    // Read the fixed bar's visibility inputs before its own mirrored DOM writes.
    // This snapshot belongs only to the current synchronous refresh.
    const readVisibility = state => {
      const version = ++visibilityVersion;
      const currentButton = state.nativeAdd;
      const rect = currentButton?.getBoundingClientRect();
      const header = document.querySelector('.wi-header-section')?.getBoundingClientRect();
      const nav = document.querySelector('.wi-bottom-nav')?.getBoundingClientRect();
      const top = header?.height > 0 ? Math.max(0, Math.min(window.innerHeight, header.bottom)) : 0;
      const bottom = nav?.height > 0 ? Math.min(window.innerHeight, nav.top) : window.innerHeight;
      // A button covered by the fixed header or mobile navigation is not usable.
      const visible = !!currentButton?.getClientRects().length && !stickyBlockedByLayer() && !!rect && (rect.top < top || rect.bottom > bottom) && !(window.innerWidth < 750 && window.innerHeight <= 500);
      return { currentButton, visible, version };
    };
    const applyVisibility = ({ currentButton, visible, version }) => {
      if (stickyVisibilityRefresh !== refreshVisibility) { cleanup(); return; }
      if (!sticky.isConnected || !product.isConnected) { refreshVisibility(); return; }
      // An interleaved focus/layer refresh owns the latest visibility decision.
      if (version !== visibilityVersion) { refreshVisibility(); return; }
      if (currentButton !== nativeButton) {
        visibilityObserver?.disconnect();
        nativeButton = currentButton;
        if (nativeButton) visibilityObserver?.observe(nativeButton);
      }
      if (sticky.classList.contains('is-visible') !== visible) sticky.classList.toggle('is-visible', visible);
      if (sticky.hidden !== !visible) sticky.hidden = !visible;
      if (sticky.inert !== !visible) sticky.inert = !visible;
      if (visible) reserveStickyHeight();
      const attentionTarget = !buyButton.hidden && !buyButton.disabled ? buyButton : (!button.disabled ? button : null);
      if (!visible || !attentionTarget || motion?.matches || sticky.wiBuyPending || sticky.contains(document.activeElement) || sticky.matches(':hover')) stopAttention();
      else if (!stickyAttentionScheduled) {
        stickyAttentionScheduled = true;
        attentionDelay = setTimeout(() => {
          if (disposed || !sticky.classList.contains('is-visible') || stickyBlockedByLayer() || motion?.matches || sticky.wiBuyPending || sticky.contains(document.activeElement) || sticky.matches(':hover')) return;
          const nextState = stickyPurchaseState(sticky);
          if (!nextState.ready) return;
          sticky.classList.add('wi-sticky-buy--attention');
          attentionEnd = setTimeout(() => sticky.classList.remove('wi-sticky-buy--attention'), 1200);
        }, 700);
      }
    };
    const refreshVisibility = () => {
      if (stickyVisibilityRefresh !== refreshVisibility) { cleanup(); return; }
      if (!sticky.isConnected || !product.isConnected) {
        cleanup();
        if (stickyVisibilityRefresh === refreshVisibility) stickyVisibilityRefresh = null;
        initStickyBuy();
        return;
      }
      applyVisibility(readVisibility(stickyPurchaseState(sticky)));
    };
    stickyVisibilityRefresh = refreshVisibility;
    const sync = () => {
      if (stickyVisibilityRefresh !== refreshVisibility) { cleanup(); return; }
      cancelObserverSync();
      const state = stickyPurchaseState(sticky);
      const { form, nativeAdd: original } = state;
      const priceContainer = product.querySelector('[id^="price-"]');
      const price = priceContainer?.classList.contains('hidden') ? null : priceContainer?.querySelector('.price');
      if (!original) { sticky.classList.remove('is-visible'); sticky.hidden = true; sticky.inert = true; stopAttention(); return; }
      const visibility = readVisibility(state);
      const disabled = !state.ready || !!sticky.wiBuyPending;
      if (button.disabled !== disabled) button.disabled = disabled;
      button.setAttribute('aria-busy', String(!!state.busy));
      const buttonText = state.busy ? 'Adding…' : (original.querySelector('span')?.textContent.trim() || original.textContent.trim());
      if (button.textContent !== buttonText) button.textContent = buttonText;
      buyButton.hidden = !state.buyReady && !sticky.wiBuyPending;
      buyButton.disabled = !state.buyReady || !!sticky.wiBuyPending;
      buyButton.setAttribute('aria-busy', String(!!sticky.wiBuyPending));
      const buyText = sticky.wiBuyPending ? 'Opening…' : 'Buy now →';
      if (buyButton.textContent !== buyText) buyButton.textContent = buyText;
      sticky.classList.toggle('wi-sticky-buy--paired', !buyButton.hidden);
      const currentPrice = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      const priceTarget = sticky.querySelector('[data-wi-sticky-price]');
      const priceText = state.selectionConfirmed ? (currentPrice?.textContent.trim().replace(/\s+/g, ' ') || '') : '';
      if (priceTarget && priceTarget.textContent !== priceText) priceTarget.textContent = priceText;
      const each = sticky.querySelector('.wi-sticky-buy__each');
      if (each) each.hidden = !priceText;
      const totalRow = sticky.querySelector('[data-wi-sticky-total-row]');
      const totalTarget = sticky.querySelector('[data-wi-sticky-total]');
      let totalText = '';
      const unitAmount = state.selectedVariant?.price;
      const totalAmount = unitAmount * state.count;
      const plan = form?.elements?.namedItem('selling_plan');
      const noSpecialVariantPrices = ['selling_plan_allocations', 'quantity_price_breaks'].every(key => state.selectedVariant?.[key] === undefined || (Array.isArray(state.selectedVariant[key]) && state.selectedVariant[key].length === 0));
      // A base-price multiplication is valid only for this server-confirmed
      // simple product. Plans and quantity tiers keep Shopify's pricing owner.
      const flatPricing = sticky.dataset.wiSubtotalSupported === 'true' && /^\d+$/.test(sticky.dataset.wiSubtotalProduct || '') && sticky.dataset.wiSubtotalProduct === product.dataset.productId && !product.quantityPriceBreaksConfigured && (!plan || (typeof plan.value === 'string' && plan.value.trim() === '')) && noSpecialVariantPrices;
      if (flatPricing && currentPrice && state.selectionConfirmed && state.quantityValid && !product.nativeSubmitDisabled && !product.quantityUnavailable && !original.disabled && state.selectedVariant?.available === true && Number.isSafeInteger(unitAmount) && unitAmount >= 0 && Number.isSafeInteger(totalAmount) && totalAmount >= 0 && /^[A-Z]{3}$/.test(sticky.dataset.wiCurrency || '')) {
        try { totalText = formatWishlistMoney(totalAmount, sticky.dataset.wiCurrency); }
        catch (_) { /* An unsupported presentment currency has no guessed total. */ }
      }
      if (totalTarget && totalTarget.textContent !== totalText) totalTarget.textContent = totalText;
      if (totalRow) totalRow.hidden = !totalText;
      const quantityTarget = sticky.querySelector('[data-wi-sticky-quantity]');
      if (quantityTarget) {
        const text = state.quantityValid ? `Qty ${state.count}` : '';
        if (quantityTarget.textContent !== text) quantityTarget.textContent = text;
        quantityTarget.hidden = !text;
      }
      const variantTarget = sticky.querySelector('[data-wi-sticky-variant]');
      if (variantTarget) {
        let confirmedTitle = '';
        if (state.selectionConfirmed && currentPrice) {
          try {
            const variant = state.selectedVariant;
            const variantId = form.querySelector('input[name="id"]')?.value;
            if (variant?.id != null && String(variant.id) === String(variantId) && typeof variant.title === 'string' && variant.title !== 'Default Title') {
              confirmedTitle = variant.title.trim();
            }
          } catch (_) { /* Incomplete native variant data has no confirmed option claim. */ }
        }
        if (variantTarget.textContent !== confirmedTitle) variantTarget.textContent = confirmedTitle;
        if (variantTarget.hidden !== !confirmedTitle) variantTarget.hidden = !confirmedTitle;
      }
      const error = sticky.querySelector('[data-wi-sticky-error]');
      const errorMessage = sticky.querySelector('[data-wi-sticky-error-message]');
      if (errorMessage) {
        const excerpt = state.errorMessage.length > 140 ? `${state.errorMessage.slice(0, 140).trimEnd()}…` : state.errorMessage;
        if (errorMessage.textContent !== excerpt) errorMessage.textContent = excerpt;
      }
      if (error) error.hidden = !state.errorWrapper;
      applyVisibility(visibility);
    };
    sticky.wiSync = sync;
    const scheduleObserverSync = () => {
      if (disposed || stickyVisibilityRefresh !== refreshVisibility || sticky.wiBoundProduct !== product) return;
      if (!sticky.isConnected || !product.isConnected) { cancelObserverSync(); refreshVisibility(); return; }
      if (document.visibilityState !== 'visible' || typeof window.requestAnimationFrame !== 'function' || typeof window.cancelAnimationFrame !== 'function') { cancelObserverSync(); sync(); return; }
      if (observerSyncFrame !== null) return;
      const version = ++observerSyncVersion;
      observerSyncFrame = window.requestAnimationFrame(() => {
        if (version !== observerSyncVersion) return;
        observerSyncFrame = null;
        if (disposed || stickyVisibilityRefresh !== refreshVisibility || sticky.wiBoundProduct !== product) return;
        if (!sticky.isConnected || !product.isConnected) { refreshVisibility(); return; }
        sync();
      });
    };
    const productObserver = new MutationObserver(scheduleObserverSync);
    productObserver.observe(product, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'hidden', 'inert', 'value', 'min', 'max', 'step'] });
    // Ignore this bar's own mirrored text/state to avoid observing our writes.
    const layers = new MutationObserver(records => { if (records.some(record => record.target !== sticky && !sticky.contains(record.target))) scheduleObserverSync(); });
    layers.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['open', 'class', 'hidden', 'aria-hidden', 'inert', 'aria-busy'] });
    const onField = event => { if (product.contains(event.target)) sync(); else refreshVisibility(); };
    const onFocus = () => { stopAttention(); refreshVisibility(); };
    const onVisibility = () => { cancelObserverSync(); stopAttention(); sync(); };
    const onPageShow = () => { clearTimeout(sticky.wiBuyCooldown); sticky.wiBuyPending = false; sync(); };
    const cleanup = () => {
      if (disposed) return;
      disposed = true;
      cancelObserverSync();
      stopAttention();
      clearTimeout(sticky.wiBuyCooldown);
      visibilityObserver?.disconnect(); productObserver.disconnect(); layers.disconnect();
      stickySizeObserver?.disconnect();
      document.documentElement?.style?.removeProperty?.('--wi-sticky-bar-height');
      product.removeEventListener('input', onField); product.removeEventListener('change', onField);
      document.removeEventListener('focusin', onFocus); document.removeEventListener('focusout', onFocus); document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', onVisibility); window.removeEventListener('pageshow', onPageShow);
      window.visualViewport?.removeEventListener('resize', refreshVisibility);
      motion?.removeEventListener?.('change', onVisibility);
      sticky.removeEventListener('pointerenter', stopAttention); sticky.removeEventListener('pointerdown', stopAttention);
      sticky.wiInitialized = false;
      sticky.wiBoundProduct = null;
      sticky.wiSync = null;
      const total = sticky.querySelector('[data-wi-sticky-total]');
      if (total) total.textContent = '';
      const totalRow = sticky.querySelector('[data-wi-sticky-total-row]');
      if (totalRow) totalRow.hidden = true;
      const error = sticky.querySelector('[data-wi-sticky-error]');
      if (error) error.hidden = true;
      const errorMessage = sticky.querySelector('[data-wi-sticky-error-message]');
      if (errorMessage) errorMessage.textContent = '';
      sticky.classList.remove('is-visible'); sticky.hidden = true; sticky.inert = true;
    };
    product.addEventListener('input', onField); product.addEventListener('change', onField);
    document.addEventListener('focusin', onFocus); document.addEventListener('focusout', onFocus); document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', onVisibility); window.addEventListener('pageshow', onPageShow);
    window.visualViewport?.addEventListener('resize', refreshVisibility, { passive: true });
    motion?.addEventListener?.('change', onVisibility);
    sticky.addEventListener('pointerenter', stopAttention); sticky.addEventListener('pointerdown', stopAttention);
    stickyCleanup = cleanup;
    sync();
  }

  document.addEventListener('worth-it:product-ready', initStickyBuy);

  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-wi-save]') || node.querySelector('[data-wi-save]'))))) syncSavedButtons();
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-wi-sticky-buy], product-info') || node.querySelector('[data-wi-sticky-buy], product-info'))))) initStickyBuy();
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('storage', event => {
    if (event.key === recentKey || event.key === null) {
      recent = readRecentHistory(event.key === null ? null : event.newValue);
      initRecentlyViewed();
    }
    if (event.key === savedKey || event.key === null) { saved = readSaved(event.key === null ? null : event.newValue); savedListChanged(); }
    if (event.key === pinKey) { pin = pinPattern.test(event.newValue || '') ? event.newValue : ''; syncPin(); }
  });
  function prepareDialogOpeners() {
    if (typeof document.querySelector('.wi-dialog')?.showModal !== 'function') return;
    document.querySelectorAll('[data-wi-open]').forEach(opener => { opener.setAttribute('aria-haspopup', 'dialog'); opener.setAttribute('aria-controls', opener.dataset.wiOpen); });
  }
  document.addEventListener('shopify:section:load', () => { bindDialogs(); syncSavedButtons(); syncPin(); initStickyBuy(); initSearchDiscovery(); bindCartCount(); prepareDialogOpeners(); bindHeaderMeasurement(); initRecentlyViewed(); });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(document.querySelector('[data-wi-sticky-buy]'))) { stickyCleanup?.(); stickyVisibilityRefresh = null; }
    if (wishlistRoot && event.target.contains(wishlistRoot)) { wishlistHandoff = null; cancelWishlist(wishlistRoot, true); wishlistRoot = null; }
    if (!recentRoot || !event.target.contains(recentRoot)) return;
    ++recentRequest;
    recentController?.abort();
    clearRecentCards(recentRoot);
    recentRoot = null;
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    saved = readSaved(); savedListChanged();
    recent = readRecentHistory();
    recordedRecentHandle = undefined;
    initRecentlyViewed();
  });
  syncSavedButtons();
  syncPin();
  bindCartCount();
  initStickyBuy();
  initSearchDiscovery();
  bindHeaderMeasurement();
  initRecentlyViewed();
  window.addEventListener('resize', updateHeaderOffset, { passive: true });
  let stickyScrollFrame;
  window.addEventListener('scroll', () => {
    if (!stickyVisibilityRefresh || stickyScrollFrame) return;
    stickyScrollFrame = requestAnimationFrame(() => { stickyScrollFrame = null; stickyVisibilityRefresh?.(); });
  }, { passive: true });
  if (typeof document.querySelector('.wi-dialog')?.showModal === 'function') {
    prepareDialogOpeners();
    document.documentElement.classList.add('wi-enhancement-ready');
    updateHeaderOffset();
  }
})();
